import { Box } from '@mui/material';
import EChartsReact, { EChartsReactProps } from 'echarts-for-react';
import React from 'react';

const PieDoughnutChart: React.FC<EChartsReactProps> = ({
    option,
    ...props
}) => {
    const baseOption = React.useMemo(
        () => ({
            title: {
                text: 'Basic Radar Chart',
            },
            tooltip: {
                trigger: 'item',
            },
            legend: {
                orient: 'vertical',
                top: 'center',
                right: '30%',
            },
            series: [
                {
                    name: 'Access From',
                    type: 'pie',
                    radius: ['50%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center',
                    },
                    labelLine: {
                        show: false,
                    },
                    data: [
                        { value: 1048, name: 'Search Engine' },
                        { value: 735, name: 'Direct' },
                        { value: 580, name: 'Email' },
                        { value: 484, name: 'Union Ads' },
                        { value: 300, name: 'Video Ads' },
                    ],
                },
            ],
        }),
        []
    );
    const mergedOption = React.useMemo(
        () => ({
            ...baseOption,
            ...option,
        }),
        [baseOption, option]
    );
    return (
        <Box>
            <EChartsReact option={mergedOption} {...props} />
        </Box>
    );
};

export default PieDoughnutChart;
